import PortalIdParser from 'PortalIdParser';
import Products from 'merchandise-lib/constants/Product';
const portalId = PortalIdParser.get();
export const navigateTo = url => {
  if (window.hubspot.wordpress) {
    window.open(url, '_top');
  } else {
    window.location.href = url;
  }
};
export const getTrialGuideUrl = (apiName, source) => {
  return `/trial-guide/${portalId}/${apiName}${source ? `?source=${source}` : ''}`;
};
export const getGlobalHomeUrl = () => `/global-home/${portalId}`;
const trialsGoingToGlobalHome = [Products.CMS_HUB_ENTERPRISE, Products.MARKETING_HUB_ENTERPRISE, Products.MARKETING_PLUS_SUITE_BUNDLE_ENTERPRISE, Products.OPERATIONS_HUB_ENTERPRISE, Products.SALES_HUB_ENTERPRISE, Products.SERVICE_HUB_ENTERPRISE, Products.COMMERCE_HUB_ENTERPRISE];
const trialsWithTrialGuide = [Products.CMS_HUB_PROFESSIONAL, Products.COMMERCE_HUB_PROFESSIONAL, Products.MARKETING_HUB_PROFESSIONAL, Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL, Products.OPERATIONS_HUB_PROFESSIONAL, Products.SALES_HUB_PROFESSIONAL, Products.SERVICE_HUB_PROFESSIONAL];
export const handleTrialStartSuccess = ({
  apiName,
  source
}) => {
  var _window$opener;
  if (typeof window !== 'undefined' && (_window$opener = window.opener) !== null && _window$opener !== void 0 && _window$opener.location.href) {
    navigateTo(window.opener.location.href);
  } else if (trialsWithTrialGuide.includes(apiName)) {
    navigateTo(getTrialGuideUrl(apiName, source));
  } else if (trialsGoingToGlobalHome.includes(apiName)) {
    navigateTo(getGlobalHomeUrl());
  } else {
    window.location.reload();
  }
};
const redirectRoutes = {
  'landing-pages': `/pages/${portalId}/manage/landing`,
  email: `/email/${portalId}/manage`,
  'marketing-workflows': `/workflows/${portalId}`,
  'content-strategy': `/content-strategy/${portalId}/clusters`,
  'sales-workflows': `/workflows/${portalId}`,
  playbooks: `/playbooks/${portalId}`,
  sequences: `/sequences/${portalId}`,
  quotes: `/quotes/${portalId}`,
  tickets: `/contacts/${portalId}/tickets/list/view/all`,
  feedback: `/feedback/${portalId}/home`,
  'knowledge-base': `/knowledge/${portalId}/insights/dashboard`,
  'service-workflows': `/workflows/${portalId}`,
  meetings: `/meetings/${portalId}`,
  'user-settings': `/settings/${portalId}/users?createUserEmail`,
  social: `/social/${portalId}/`,
  seo: `/content-strategy/${portalId}/recommendations`,
  forecasting: `/forecasting/${portalId}`,
  'live-messages-settings': `/live-messages-settings/${portalId}`,
  'custom-coded-workflow-actions': `/workflows/${portalId}`,
  'custom-coded-bot-actions': `/chatflows/${portalId}`,
  webhooks: `/workflows/${portalId}`,
  'data-quality-automation': `/workflows/${portalId}`,
  campaigns: `/marketing/${portalId}/campaigns`,
  datasets: `/data-studio/${portalId}/dataset`,
  'snowflake-data-share': `/ecosystem/${portalId}/marketplace/apps/productivity/connector/snowflake`,
  payments: `/settings/${portalId}/sales/payments`
};
export const mapRedirectTargetToRouteFromApiName = (redirectTarget, apiName) => {
  if (redirectTarget !== 'other' && redirectRoutes[redirectTarget]) {
    return redirectRoutes[redirectTarget];
  }
  const hub = apiName ? apiName.split('-')[0] : '';
  return `/reports-dashboard/${portalId}/${hub}`;
};
export const addDaysToDate = (startDate = new Date(), daysToAdd = 0) => {
  const result = new Date(startDate);
  result.setDate(result.getDate() + daysToAdd);
  return result;
};